<template>
  <div v-if="filteredMenu.length > 0" id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto h-100">
    <ul class="navbar-nav">
      <template v-for="(group, gIndex) in filteredMenu" :key="gIndex">
        <!-- Group Heading -->
        <li v-if="group.group" class="nav-item mt-2">
          <h6
            v-if="isPinned"
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
            :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
          >
            {{ group.group }}
          </h6>
        </li>
        <hr v-if="group.group" class="mt-0 horizontal dark" />

        <!-- Menu Items -->
        <li v-for="item in group.items" :key="item.path" class="nav-item">
          <sidenav-collapse
            :nav-text="item.label"
            :collapse="false"
            url="#"
            :aria-controls="''"
            :class="currentRoute === item.path.replace(/^\//, '') ? 'active' : ''"
            :collapse-ref="item.path"
          >
            <template #icon>
              <component :is="item.icon" />
            </template>
          </sidenav-collapse>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { markRaw } from "vue";
import { mapState } from "vuex";

import IconDashboard from "@/shared/Controls/Icons/IconDashboard.vue";
import IconStrain from "@/shared/Controls/Icons/IconStrain.vue";
import IconRecovery from "@/shared/Controls/Icons/IconRecovery.vue";
import IconSleep from "@/shared/Controls/Icons/IconSleep.vue";
import IconUser from "@/shared/Controls/Icons/IconUser.vue";
import IconCommunity from "@/shared/Controls/Icons/IconCommunity.vue";
import IconManageUser from "@/shared/Controls/Icons/IconManageUser.vue";
import IconKnowledge from "@/shared/Controls/Icons/IconKnowledge.vue";
import IconManageChallenge from "@/shared/Controls/Icons/IconManageChallenge.vue";
import IconLeaderboard from "@/shared/Controls/Icons/IconLeaderBoard.vue";
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: 'SideNavListV2',
    components: {
    IconDashboard,
    IconStrain,
    IconRecovery,
    IconSleep,
    IconUser,
    IconCommunity,
    IconManageUser,
    IconKnowledge,
    IconManageChallenge,
    IconLeaderboard,
    SidenavCollapse,
  },
  data() {
    return {
      loginUser: null,
      rawMenu: [
        {
          group: '',
          roles: [1, 2, 3, 4], // Admin, Manager, User, Commander
          items: [
            { label: 'Dashboard', path: '/dashboards/home', icon: markRaw(IconDashboard), roles: [1, 2, 3,4] },
            { label: 'Leader Board', path: '/overview/leaderboard', icon: markRaw(IconLeaderboard), roles: [1,3,4,5] },
          ]
        },
        {
          group: 'OVERVIEW',
          roles: [1,2,3,4,5], // Admin, Manager, User, Commander
          items: [
            { label: 'Strain', path: '/overview/strain', icon: markRaw(IconStrain), roles: [1, 2, 3,4] },
            { label: 'Recovery', path: '/overview/recovery', icon: markRaw(IconRecovery), roles: [1, 2, 3,4] },
            { label: 'Sleep', path: '/overview/sleep', icon: markRaw(IconSleep), roles: [1, 2, 3,4] },
            { label: 'Users', path: '/overview/users', icon: markRaw(IconUser), roles: [1, 2, 3,4] },
            { label: 'Recommended Profiles', path: '/overview/ai_profiler', icon: markRaw(IconCommunity), roles: [1,2, 3, 4] },
            { label: 'Top Profiles', path: '/overview/top_profiles', icon: markRaw(IconCommunity), roles: [] },
          ]
        },
        {
          group: 'MANAGE',
          roles: [1,3,4,5],
          items: [
            { label: 'User Accounts', path: '/manage/users', icon: markRaw(IconManageUser), roles: [1,3,4,5] },
            { label: 'Challenges', path: '/manage/challenges', icon: markRaw(IconManageChallenge), roles: [] },
          ]
        },
        {
          group: "Information",
          roles: [1,2,3,4],
          items: [
            { label: 'Knowledge Base', path: '/help/knowledgebase', icon: markRaw(IconKnowledge), roles: [1,2,3,4] },
          ]
        }
      ],
      filteredMenu: [],
    };
  },
  mounted() {
    this.loginUser = this.$store.getters["auth/getLoggedInUser"]();
    if (this.loginUser) {
        this.filterMenusByRole();
    }
  },
  methods: {
    filterMenusByRole() {
      this.filteredMenu =  this.rawMenu
        .map(group => ({
          group: group.group,
          items: group.items.filter(item => item.roles.includes(this.loginUser.role.role_id))
        }))
        .filter(group => group.items.length > 0);
    },
  },
  computed: {
     ...mapState(["isPinned"]),
    currentRoute() {
      return this.$route.path.replace(/^\//, '');
    }
  }
};

</script>